import React from "react";
import FaPlus from "react-icons/lib/fa/plus";
import FaMinus from "react-icons/lib/fa/minus";
import Loading from "../../../Global/Loading";
import { useTranslation } from "react-i18next";

export default function Resources(props) {
  const { resources, expanded, setExpanded } = props;

  const {t} = useTranslation("skills_status_report");

  if (!resources)
    return (
      <div style={{ height: 300 }}>
        <Loading />
      </div>
    );

  let rendered = resources;
  if (!expanded && rendered[0]) rendered = [resources[0]];

  return (
    <div className="skillmodal-resources">
      {rendered.map((r, i) => (
        <div key={i} className="skillmodal-resource">
          <img src={r.resourceIcon} className="skillmodal-resourceicon" />
          <div>
            <a
              className="skillmodal-resourcelabel"
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {r.label}
            </a>
            <img src={r.branding} className="skillmodal-resourcebranding" />
          </div>
        </div>
      ))}
      {renderExpandButton()}
    </div>
  );

  function renderExpandButton() {
    if (!resources[0])
      return <div className="placeholder-text">{t("no_resources")}</div>;

    // don't show button if only 1 resource
    if (resources.length === 1) return;

    if (!expanded)
      return (
        <div className="expandButton" onClick={() => setExpanded(true)}>
          <FaPlus size="16" className="expandIcon" />
          View More Resources
        </div>
      );

    return (
      <div className="expandButton" onClick={() => setExpanded(false)}>
        <FaMinus size="16" className="expandIcon" />
        View Fewer Resources
      </div>
    );
  }
}
